"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
var jsx_runtime_1 = require("react/jsx-runtime");
var SvgEdit03 = function (props) { return ((0, jsx_runtime_1.jsx)("svg", __assign({ width: 24, height: 24, viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, props, { children: (0, jsx_runtime_1.jsx)("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M11 20a1 1 0 0 1 1-1h9a1 1 0 1 1 0 2h-9a1 1 0 0 1-1-1ZM15.793 2.793a3.121 3.121 0 1 1 4.414 4.414L7.644 19.77l-.058.059c-.288.288-.541.542-.847.729a3 3 0 0 1-.867.36C5.524 21 5.165 21 4.758 21H3a1 1 0 0 1-1-1v-1.758c0-.407 0-.765.083-1.114a3 3 0 0 1 .36-.867c.186-.306.44-.56.728-.846l.06-.06L15.792 2.794Z", fill: "currentColor" }) }))); };
exports.default = SvgEdit03;
